'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function BibSubtitle(_ref) {
  var subtitle = _ref.subtitle,
      _ref$titleTag = _ref.titleTag,
      titleTag = _ref$titleTag === undefined ? 'h5' : _ref$titleTag;

  var TitleTag = titleTag; // This needs to start with an uppercase letter since its a component
  if (subtitle) {
    return _react2.default.createElement(
      TitleTag,
      { className: 'cp-subtitle' },
      subtitle
    );
  }

  return _react2.default.createElement('noop', null);
}

BibSubtitle.propTypes = {
  subtitle: _react.PropTypes.string,
  titleTag: _react.PropTypes.string
};

exports.default = BibSubtitle;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/shared-bib-subtitle/lib/components/BibSubtitle.component.js
// module id = 1232
// module chunks = 0